var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPriceUp = function SvgPriceUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.598 12.031c.116.279-.209.54-.458.37-1.08-.74-2.847-1.901-3.289-1.901-.43 0-1.991 1.105-2.989 1.846-.244.181-.582-.073-.473-.357L7.582 3.7a.3.3 0 0 1 .557-.007z"
  })));
};
export { SvgPriceUp as ReactComponent };
export default __webpack_public_path__ + "4c03f48ecdbfb414c8e784413437d74f.svg";